import rootReducer from './rootReducer';
import { configureStore } from '@reduxjs/toolkit';
import { persistTheme } from './slices/themeSlice';

const middlewares = [];

const store = configureStore({
	reducer: rootReducer(),
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			immutableCheck: false,
			serializableCheck: false,
		}).concat(middlewares),
	devTools: process.env.NODE_ENV === 'development',
})

store.asyncReducers = {};

let previousTheme = store.getState().theme;
store.subscribe(() => {
	const theme = store.getState().theme;
	if (theme === previousTheme) {
		return;
	}
	previousTheme = theme;
	persistTheme(theme);
});

export const injectReducer = (key, reducer) => {
	if (store.asyncReducers[key]) {
		return false;
	}
	store.asyncReducers[key] = reducer;
	store.replaceReducer(rootReducer(store.asyncReducers));
	return store
}

export default store